import { useNavigate } from "react-router-dom";

// ─────────────────────────────────────────────────────────────
// Gates any UI element behind a service flag. Theme-aware version
// of the original — same logic, tokens swapped in for hardcoded
// slate/amber hex classes.
// ─────────────────────────────────────────────────────────────

const SERVICE_ICONS = {
  trading:          "ri-exchange-dollar-line",
  deposits:         "ri-arrow-down-circle-line",
  withdrawals:      "ri-arrow-up-circle-line",
  naira_withdrawal: "ri-bank-line",
  bills:            "ri-receipt-line",
  fiat_deposit:     "ri-money-dollar-circle-line",
  rewards:          "ri-gift-line",
  kyc:              "ri-shield-user-line",
  support_chat:     "ri-customer-service-2-line",
  savings:          "ri-piggy-bank-line",
  payroll:          "ri-team-line",
  payment_link:     "ri-link",
  internal_transfer:"ri-exchange-line",
};

export default function ServiceGate({ serviceKey, services = {}, children, fullPage = false }) {
  const navigate = useNavigate();

  if (!services || Object.keys(services).length === 0) return children;

  const svc = services[serviceKey];
  if (!svc || svc.enabled) return children;

  const icon    = svc.icon || SERVICE_ICONS[serviceKey] || "ri-tools-line";
  const name    = svc.name || serviceKey;
  const message = svc.disabledMessage || "This service is temporarily unavailable.";

  if (fullPage) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[70vh] px-6 text-center">
        <div className="w-20 h-20 rounded-3xl bg-surface-hover flex items-center justify-center mx-auto mb-5">
          <i className={`${icon} text-muted text-4xl`} />
        </div>
        <h2 className="text-primary font-bold text-xl mb-2 font-display">{name} Unavailable</h2>
        <p className="text-muted text-sm leading-relaxed mb-8 max-w-xs">{message}</p>
        <button
          onClick={() => navigate("/home")}
          className="px-8 py-3 bg-brand hover:bg-brand-hover text-on-brand font-semibold rounded-2xl text-sm transition-colors"
        >
          Back to Home
        </button>
      </div>
    );
  }

  return (
    <div className="bg-warning-light border border-warning-border rounded-2xl px-4 py-4 flex items-start gap-3">
      <div className="w-9 h-9 rounded-xl bg-warning-light flex items-center justify-center flex-shrink-0 mt-0.5"
        style={{ background: "var(--color-warning-border)" }}>
        <i className={`${icon} text-lg`} style={{ color: "var(--color-warning)" }} />
      </div>
      <div>
        <p className="text-warning-text text-sm font-semibold mb-0.5">{name} Unavailable</p>
        <p className="text-warning-text text-xs leading-relaxed opacity-90">{message}</p>
      </div>
    </div>
  );
}